import { createColumnHelper } from '@tanstack/table-core';
import { DataScienceTask } from '../tasks.models';
import { FieldCell } from 'common/components/table/cell-formatters/fieldCell';
import DataScienceTasksTableStatus from './tasks-table-status';
import DataScienceTaskTableActions from './tasks-table-actions';
import { StickyOptions } from 'common/components/table/tableTypes';

const columnHelper = createColumnHelper<DataScienceTask>();
export const getDataScienceTasksColumnDefs = () => [
  columnHelper.accessor((row) => row.machineLearningModel, {
    id: 'MachineLearningModel',
    header: () => 'Machine Learning Model',
    cell: (info) => <span className="text-sm font-bold">{info.getValue()}</span>
  }),
  columnHelper.accessor((row) => row.hasAvailableModel, {
    id: 'HasAvailableModel',
    header: () => 'Available Model',
    cell: (info) => {
      const hasAvailableModel = info.getValue();
      const displayText = hasAvailableModel ? 'Yes' : 'No';
      return <span className="text-sm">{displayText}</span>;
    }
  }),
  columnHelper.accessor((row) => row.status, {
    id: 'DataScienceTaskStatus',
    header: () => 'Status',
    cell: (info) => (
      <DataScienceTasksTableStatus
        currentStatus={info.getValue()}
        machineLearningModel={info.row.original.machineLearningModel}
        dataScienceTaskFailureInformation={
          info.row.original.dataScienceTaskFailureInformation
        }
      />
    )
  }),
  columnHelper.accessor((row) => row.schedule, {
    id: 'CronSchedule',
    header: () => 'Cron Schedule',
    cell: (info) => <span className="text-sm">{info.getValue()}</span>
  }),
  columnHelper.accessor((row) => row.lastProcessed, {
    id: 'LastProcessed',
    header: () => 'Last Processed',
    cell: (info) => <span className="text-sm">{info.getValue()}</span>
  }),
  columnHelper.accessor((row) => row.lastTriggered, {
    id: 'LastTriggered',
    header: () => 'Last Triggered',
    cell: (info) => <span className="text-sm">{info.getValue()}</span>
  }),
  columnHelper.accessor((row) => row.autoDeployModelOnTrainingComplete, {
    id: 'AutoDeployModelOnTrainingComplete',
    header: () => 'Auto Deploy Model',
    cell: (info) => {
      const autoDeployModelOnTrainingComplete = info.getValue();
      const displayText = autoDeployModelOnTrainingComplete ? 'Yes' : 'No';
      return <span className="text-sm">{displayText}</span>;
    }
  }),
  columnHelper.accessor((row) => row.pipelineParameterOverrides, {
    id: 'PipelineParameterOverrides',
    header: () => 'Pipeline Parameter Overrides',
    cell: (info) => {
      if (Array.isArray(info.getValue())) {
        return (
          <div className="space-y-1">
            {info.getValue().map((param, index) => (
              <div className="text-xs" key={index}>
                <FieldCell
                  identifier={param.name}
                  value={param.value}
                ></FieldCell>
              </div>
            ))}
          </div>
        );
      }

      return null;
    }
  }),
  columnHelper.accessor((row) => row.machineLearningModel, {
    id: 'actions',
    header: () => 'Actions',
    cell: (info) => (
      <DataScienceTaskTableActions dataScienceTask={info.row.original} />
    ),
    maxSize: 50,
    meta: {
      stickyOptions: {
        isEnabled: true,
        side: 'right'
      } as StickyOptions
    }
  })
];
